export function releaseVersion(value: unknown): string | null {
  return typeof value === 'string' && /^[a-f0-9]{40}$/.test(value) ? value : null
}

export function loadedRelease(): string | null {
  return releaseVersion(document.querySelector<HTMLMetaElement>('meta[name="bramble-release"]')?.content)
}
